import React from "react";
import SubPageShell from "@/apps/rider/components/SubPageShell";

export default function PrivacyPolicy() {
  return (
    <SubPageShell
      eyebrow="Legal"
      title="Privacy policy"
      subtitle="What we collect, how we use it, and your control over your data."
      back="/account"
      backLabel="Account"
      testId="privacy-page"
    >
      <article className="prose prose-sm sm:prose-base max-w-none text-[#0A1128]" data-testid="privacy-content">
        <p className="text-[#515E7B]">Last updated: February 2026</p>

        <h2 className="font-serif text-xl mt-6">What we collect</h2>
        <p>
          Your name, email, phone number, profile picture, the addresses you save,
          the routes you book, and the rides we run. Drivers also see your name and
          pickup window when they're assigned to your trip — never your phone number
          unless you explicitly contact them.
        </p>

        <h2 className="font-serif text-xl mt-6">Why we collect it</h2>
        <p>
          To run the rides you've scheduled, charge the right amount, send you
          arrival alerts, and keep your account secure. Anonymous, aggregated data
          may be used to improve the service (e.g. average commute distance per
          tier) — never tied back to your individual identity.
        </p>

        <h2 className="font-serif text-xl mt-6">Payments</h2>
        <p>
          Card numbers never touch our servers. All payments run through Stripe;
          we store only Stripe's reference (a customer id and a payment-method id)
          plus the brand and last four digits for your reference.
        </p>

        <h2 className="font-serif text-xl mt-6">Notifications</h2>
        <p>
          Push notifications are sent through Firebase Cloud Messaging. You can
          turn them off anytime in <a className="text-[#ed6500] underline-offset-4 hover:underline" href="/preferences/notifications">Preferences → Notifications</a>
          {" "}or in your device settings.
        </p>

        <h2 className="font-serif text-xl mt-6">Your data, your call</h2>
        <p>
          Email <a className="text-[#ed6500]" href="mailto:lamar@lefcoholdings.com">lamar@lefcoholdings.com</a> from the address on your
          account to export, correct, or delete your data. We respond within seven
          business days.
        </p>

        <h2 className="font-serif text-xl mt-6">Children</h2>
        <p>
          Link is for adult riders. Account creation requires the rider to be 18 or older.
        </p>

        <h2 className="font-serif text-xl mt-6">Changes</h2>
        <p>
          When this policy materially changes, you'll see a banner the next time you sign in.
          Continued use after the banner constitutes acceptance.
        </p>
      </article>
    </SubPageShell>
  );
}
